/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropPointsLeaderboardEntry
 */
export interface DropPointsLeaderboardEntry {
    /**
     * 
     * @type {string}
     * @memberof DropPointsLeaderboardEntry
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof DropPointsLeaderboardEntry
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof DropPointsLeaderboardEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof DropPointsLeaderboardEntry
     */
    balance: number;
    /**
     * 
     * @type {number}
     * @memberof DropPointsLeaderboardEntry
     */
    totalEarned: number;
    /**
     * 
     * @type {number}
     * @memberof DropPointsLeaderboardEntry
     */
    rank: number;
}

/**
 * Check if a given object implements the DropPointsLeaderboardEntry interface.
 */
export function instanceOfDropPointsLeaderboardEntry(value: object): value is DropPointsLeaderboardEntry {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('totalEarned' in value) || value['totalEarned'] === undefined) return false;
    if (!('rank' in value) || value['rank'] === undefined) return false;
    return true;
}

export function DropPointsLeaderboardEntryFromJSON(json: any): DropPointsLeaderboardEntry {
    return DropPointsLeaderboardEntryFromJSONTyped(json, false);
}

export function DropPointsLeaderboardEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropPointsLeaderboardEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'displayName': json['displayName'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'balance': json['balance'],
        'totalEarned': json['totalEarned'],
        'rank': json['rank'],
    };
}

export function DropPointsLeaderboardEntryToJSON(json: any): DropPointsLeaderboardEntry {
    return DropPointsLeaderboardEntryToJSONTyped(json, false);
}

export function DropPointsLeaderboardEntryToJSONTyped(value?: DropPointsLeaderboardEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'avatarUrl': value['avatarUrl'],
        'balance': value['balance'],
        'totalEarned': value['totalEarned'],
        'rank': value['rank'],
    };
}

